import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const EditLink = ({ url, label, className }) => {
  return (
    <a
      className={classNames('btn text-decoration-underline', className)}
      aria-label={label}
      href={url}>
      <i className="fas fa-pencil-alt mr-1" aria-hidden="true"></i>
      Edit
    </a>
  );
};

EditLink.propTypes = {
  url: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export { EditLink };
